var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Instagram_icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 38
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Instagram_icon",
    "data-name": "Instagram icon",
    clipPath: "url(#clip-Instagram_icon)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(0.997 0.446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M42.453,18.5A18.5,18.5,0,1,1,23.949,0a18.5,18.5,0,0,1,18.5,18.5",
    transform: "translate(-4.526)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M142.878,68.176a1.272,1.272,0,1,0,1.272,1.272,1.272,1.272,0,0,0-1.272-1.272",
    transform: "translate(-117.712 -56.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M89.31,77.843a5.343,5.343,0,1,0,5.343,5.343,5.349,5.349,0,0,0-5.343-5.343m0,8.766a3.423,3.423,0,1,1,3.422-3.423,3.426,3.426,0,0,1-3.422,3.423",
    transform: "translate(-69.798 -64.708)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M65.995,66.914H57.333A6.524,6.524,0,0,1,50.816,60.4V51.735a6.524,6.524,0,0,1,6.517-6.517h8.662a6.524,6.524,0,0,1,6.517,6.517V60.4a6.524,6.524,0,0,1-6.517,6.517M57.333,47.259a4.48,4.48,0,0,0-4.476,4.475V60.4a4.481,4.481,0,0,0,4.476,4.476h8.662A4.481,4.481,0,0,0,70.471,60.4V51.735a4.481,4.481,0,0,0-4.476-4.475Z",
    transform: "translate(-42.241 -37.588)",
    fill: "#fff"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.a955f97847da408bbbbedf5b2719b70f.svg";
export { ForwardRef as ReactComponent };